<template>
    <transition :name="transition" mode="in-out" appear :appear-active-class="enterClass" :enter-active-class="enterClass" :leave-active-class="leaveClass" @after-leave="afterLeave">
        <article class="message animated" :class="['is-' + type, 'direction-' + this.direction]" v-if="show">
            <div class="message-header">
                <p v-html="this.title"></p>
                <button class="delete touchable" @click.prevent="close()"></button>
            </div>
                <div class="message-body" v-html="this.body"></div>
        </article>
    </transition>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'notification',
        props: {
            value: {
                type: Object,
                'default': () => { return {}; },
            },
        },
        data() {
            return {
                closeTimeout: null,
                show: true,
            };
        },
        created() {
            if(this.duration) {
                this.closeTimeout = setTimeout(() => {
                    this.close();
                }, this.duration);
            }
        },
        destroyed() {
            clearTimeout(this.closeTimeout);
        },

        mounted() {
            try {
                this.addAnchorEvents();
            } catch (e) {
                Vue.nextTick(() => {
                    try {
                        this.addAnchorEvents();
                    } catch (e) {
                        Vue.nextTick(() => {
                            try {
                                this.addAnchorEvents();
                            } catch (e) {}
                        });
                    }
                });
            }
        },

        computed: {
            transition() {
                return `bounce-${this.direction}`;
            },

            enterClass() {
                let d = this.direction;
                if(d === 'Up') {
                    d = 'Down';
                } else if(d === 'Down') {
                    d = 'Up';
                }
                return `bounceIn${d}`;
            },

            leaveClass() {
                return `bounceOut${this.direction}`;
            },

            title() {
                return this.value.title;
            },
            body() {
                return this.value.body;
            },
            type() {
                return this.value.type || 'primary';
            },
            direction() {
                return this.value.direction || 'Right';
            },
            duration() {
                if(this.value.duration === undefined) {
                    return 5000;
                }
                return this.value.duration;
            },
        },

        methods: {
            close() {
                clearTimeout(this.closeTimeout);
                this.$emit('close');
            },

            afterLeave() {
                this.$destroy();
            },

            addAnchorEvents() {
                for(let a of this.$el.getElementsByTagName('a')) {
                    a.addEventListener('click', (event) => {
                        const href = a.getAttribute('href');
                        if(href && href.startsWith('/')) {
                            event.preventDefault();
                            this.close();
                            this.$router.push(href);
                        }
                    });
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/components/notifications/notification.vue